/** Created by azhou on 2019/2/25.*/
<template>
    <div class="text-left pt-2 pb-2 pl-5 pr-5">
      <!--页面详情头部-->
      <!--酒店-企业用户-->
      <div v-if="isGroup">
        <div class="mb-2 d-center-start">
          <img v-lazy="'/images/public/rz_2.png'" height="24px" class="mr-1 mt-1" alt="已认证" v-if="storeInfo.type==2"/>
          <label class="h3 font-weight-bold  los" @click="IDetails(userHeadInfo.exp_img)" >
              {{userHeadInfo.title}}
              <img v-lazy="'/images/xj/icon_'+userHeadInfo.star+'.png'" :key="userHeadInfo.star" height="20px" v-if="storeInfo.type === 3"/>
          </label>
          <el-button class="bg-login text-white ml-auto" @click="$router.push('/')">去订单雨首页</el-button>
        </div>
        <div class="d-center-start w-100">
          <div class="d-center" v-if="storeInfo.type === 3">
            活跃等级：<span class="text-danger">{{userHeadInfo.exp_level}}级</span>
            <img :src="userHeadInfo.exp_img ? '/images/grade/'+ userHeadInfo.exp_img : ''" class="cursor-pointer ml-1 mr-3" height="20px"
                @click="$router.push({name:'GradeManage',query:{tab:'levelrules'}})">
            活跃值：<span class="text-link mr-3" @click="$router.push({name:'GradeManage',query:{tab:'activedetails',storeId:storeInfo.storeId}})">{{userHeadInfo.exp}}点</span>
          </div>
          <label v-if="showHead">
            门店余额：<span >&yen; {{(userHeadInfo.money/100) | formatMoney}}</span>
          </label>
          <div class="ml-auto" >
            <template v-for="(item,index) in toolTips">
              <el-tooltip effect="dark" :content="item.content" placement="bottom"  :key="item.iconfont" v-if="index<2&&storeInfo.type === 3">
                <i :class="['iconfont mr-2 text-login cursor-pointer',item.iconfont]" @click="$router.push(item.link)">
                  <span class="text-xiaoxi" v-if="item.iconfont==='icon-xiaoxi'&&unReadMsg>0">{{ unReadMsg }}</span>
                </i>
              </el-tooltip>
            </template>
            <span class="text-muted ml-2">客服电话：0571-89986918</span>
          </div>
        </div>
      </div>
      <!--酒店-销售用户-->
      <div v-if="!isGroup">
        <div class="mb-2 d-center-start">
          <!-- <i class="iconfont icon-renzheng text-warning mr-1"></i> -->
           <div v-if="storeInfo.type==2">
              <img v-lazy="'/images/public/rz_1.png'" height="24px" class="mr-1 mt-2" alt="未认证" v-if="storeInfo.level==4"/>
              <img v-lazy="'/images/public/rz_2.png'" height="24px" class="mr-1 mt-2" alt="已认证" v-if="storeInfo.level==3"/>
           </div>
          <span class="mr-1">{{userHeadInfo.truename}}</span><i class="iconfont icon-xiugai1 text-link" @click="changeUserName" style="font-size: 16px;"></i>
          <label class="text-muted ml-3">当前绑定手机号：{{userHeadInfo.mobile | formatPhone}}</label>
          <div class="currentHotel" v-if="this.storeInfo.type==3">
            <div>当前酒店：</div>
            <el-select v-model="storeInfo.storeId" placeholder="请选择操作酒店" @change="onPtions" style="width: 220px">
              <el-option style="width: 220px" :label="item.title" :value="item.id" :key="item.id" v-for="item in salesAssociationLists.lists"></el-option>
              <el-option label="全部酒店" value="0"></el-option>
            </el-select>
          </div>
          <el-button class="bg-login text-white" :class="{'ml-auto':this.storeInfo.type==2}" @click="$router.push('/')">去订单雨首页</el-button>
        </div>
        <div class="d-center-start w-100">
          <div>
            积分：<span class="text-info mr-3 text-link" @click="$router.push({name:'GradeManage',query:{tab:'activedetails'}})">{{userHeadInfo.sex}}</span>
          </div>  
          <!-- <label v-if="showHead">
            门店余额：<span >&yen; {{(userHeadInfo.money/100) | formatMoney}}</span>
          </label> -->
          <div class="ml-auto">
            <el-tooltip effect="dark" content="用户实名认证" placement="bottom">
                <i class="iconfont icon-shenfenzheng mr-2 cursor-pointer wechat" @click="$router.push({name:'AccountSet',query:{type:'identity'}})" :class="{'text-login':userLoginMessage.is_real==1}"></i>
              </el-tooltip>
            <el-tooltip effect="dark" :content="item.content" placement="bottom" v-for="item in toolTips" :key="item.iconfont">
              <i :class="['iconfont mr-2 text-login cursor-pointer',item.iconfont]" @click="$router.push(item.link)">
                <span class="text-xiaoxi" v-if="item.iconfont==='icon-xiaoxi'&&unReadMsg>0">{{ unReadMsg }}</span>
              </i>
            </el-tooltip>
            <span class="text-muted ml-2">客服电话：0571-89986918</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { data } from 'jquery';
import { options } from 'numeral';
import { mapState,mapGetters, mapActions,mapMutations} from 'vuex'
import temp from '../Admin/FinancialManage/FinancialStats/EchartStat/temp.vue';

  export default {
  components: { temp },
    name: 'UserHeader',
    computed: {
      ...mapState(['userHeadInfo','userLoginMessage','salesAssociationLists']),
      ...mapGetters(['storeInfo','unreadTotal','isGroup','unReadMsg']),
      //用户头部icon链接
      toolTips() {
        let arr = [
          {content:'排行榜',iconfont:'icon-paihangbang',link:{name:'GradeManage',query:{}}},
          // {content:'我的邮箱',iconfont:'icon-youjian',link:{name:'AccountSet',query:{type:'email'}}},
          {content:'消息中心',iconfont:'icon-xiaoxi',link:{name:'MsgLists',query:{msg_type:'2'}}},
          {content:'绑定微信，接收订单通知',iconfont:'icon-weixin1',link:{name:'AccountSet',query:{type:'wechat'}}},
          {content:'管理绑定手机',iconfont:'icon-shouji',link:{name:'AccountSet',query:{type:'phone'}}},
        ]
        if (this.storeInfo.type === 2) arr[0]={content:'积分明细',iconfont:'icon-jifen',link:{name:'GradeManage',query:{}}}
        return arr;
      },
      showHead () {
        return !this.isGroup || (this.isGroup && this.userLoginMessage.store_id_arr.length == 1 && this.userHeadInfo.level != 1)
      }
    },
    //获取用户积分/活跃度信息
    created() {
      //获取供应商酒店活跃度
      if(this.isGroup){
        this.getUserHead();
      }else{
        this.updateInfo();
      }
      //获取个人用户积分
      if(this.storeInfo.type === 3&&this.storeInfo.level==3) {
        //已选中关联酒店为空测重新调取
        if(this.salesAssociationLists.total==0&&this.storeInfo.type==3){
          this.POST_UnionRecordSaleList({data:{},successFun:()=>{}})
        }
      }
    },
    data() {
      return {
        region:0,
      }
    },
    methods:{
      ...mapActions(['getUserHead','modifyTruename','updateInfo','POST_UnionRecordSaleList']),
      ...mapMutations(['UPDATECURRENTSTORE','UPDATELOGININFO']),
      //修改用户名称
      changeUserName() {
        this.$prompt('请输入新名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\u4e00-\u9fa5A-Za-z]{1,16}$/,
          inputErrorMessage: '请填写正确的联系人姓名'
        }).then(({ value }) => {
          this.modifyTruename({
            truename:value
          })
        }).catch(() => {});
      },
      IDetails(id) {
        if(id){
          this.$router.push('/index_hotel/hotel_detail/' +this.storeInfo.storeId);
        }
      },
      //切换酒店或点击全部返回酒店页面
      onPtions(e){
        console.log(e);
        //点击全部清空酒店ID
        if(e==0){
          let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
            userMessage.storeId = 0;
           this.UPDATELOGININFO(userMessage)
        }
        else{
          //切换酒店
          let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
          userMessage.storeId = e;
          this.UPDATELOGININFO(userMessage);
          this.$router.push({ name: 'CenterIndex' });
          window.location.reload();
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  .contract-type{
    padding: 3px 8px;
    font-size: 14px;
    margin-left: 10px;
    >.iconfont{font-size: 14px;}
  }
  .purple{
    color:  #B8A6D8;
    margin-left: 5px;
    font-size: 16px
  }
  .los{
    cursor: pointer;
    display: flex;
    img{
      margin-top: 5px;
      margin-left: 4px;
    }
  }
  .cursor-pointer{
    position: relative;
  }
  .text-xiaoxi{
    position: absolute;
    width: 14px;
    height: 14px;
    background-color: red;
    color: #Fff;
    color: #fff;
    top: -4px;
    right: -4px;
    font-size: 10px;
    text-align: center;
    line-height: 14px;
    border-radius: 50px;
  }
  .paihangbang i{
    font-size: 14px;
  }
  .currentHotel{
    margin-left: auto;
    margin-right: 20px;
    display: flex;
    line-height: 40px;
  }
  .wechat{
    color: #999;
  }
</style>